// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__t8+7U","content":"MainLayout_content__f3a+U"};